import { parseISO, isValid, format } from 'date-fns';
import { YEAR_UNKNOWN_SENTINEL } from '../traveler-details/traveler-personal-details.utils';

/**
 * Format a significant date string for display:
 * - Known year  → "August 3, 1957"
 * - Unknown year (sentinel 1900) → "June 22"
 * Returns undefined for empty or invalid input.
 */
const formatSignificantDate = (date: string | undefined): string | undefined => {
  if (!date?.trim()) return undefined;
  const parsed = parseISO(date);
  if (!isValid(parsed)) return date;
  const localDate = new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
  if (localDate.getFullYear() === YEAR_UNKNOWN_SENTINEL) {
    return format(localDate, 'MMMM d');
  }
  return format(localDate, 'MMMM d, yyyy');
};

export default formatSignificantDate;
